import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../Firebase/firebase-config";
import { onAuthStateChanged } from "firebase/auth";
import AuthService from "../Auth/AuthService";
import PartnerLoginModal from "./PartnerLoginModal";

const PartnerLogin = () => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const [isMainUser, setIsMainUser] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsChecking(false);
        return;
      }

      // Check if this is a main user
      const userProfile = await AuthService.getUserProfile(user.uid);
      
      if (userProfile && userProfile.type === "main") {
        setIsMainUser(true);
      }

      setIsChecking(false);
    });

    return () => unsubscribe();
  }, []);

  if (isChecking) {
    return (
      <div className="partner-login-loading">
        <div className="loading-spinner"></div>
        <p>Verifying account type...</p>
      </div>
    );
  }

  // Show restricted message if user is Main Account Holder
  if (isMainUser) {
    return (
      <div className="partner-login-restricted">
        <div className="restricted-card">
          <div className="icon-warning">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h2>Access Restricted</h2>
          <p>
            You are logged in as the <strong>Main Account Holder</strong>.<br />
            Partner login is only for authorized partners and viewers.
          </p>
          <p style={{ fontSize: "14px", color: "#666", margin: "20px 0" }}>
            Please use the regular login to access your dashboard.
          </p>

          <button
            className="auth-button primary"
            onClick={() => navigate("/login")}
          >
            Go to Main Login
          </button>

          <button
            className="text-button"
            onClick={() => navigate("/")}
            style={{ marginTop: "12px" }}
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return <PartnerLoginModal isOpen={true} onClose={() => navigate("/login")} />;
};

export default PartnerLogin;